import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@Component({
	selector: 'app-checkbox-control',
	standalone: true,
	imports: [ReactiveFormsModule, NzFormModule, NzCheckboxModule],
	templateUrl: './checkbox-control.html',
})
export class CheckboxControl {
	label = input.required<string>();
	controlName = input.required<string>();
	formGroup = input.required<FormGroup>();
	required = input<boolean>(false);
}
